var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrosstable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6H86.6667C90.7293 6 94 9.27103 94 13.3341V22.9588C94 27.0219 90.7293 30.293 86.6667 30.293H13.3333C9.27067 30.293 6 27.0219 6 22.9588V13.3341C6 9.27103 9.27067 6 13.3333 6Z",
    fill: "#00A1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 36.3381H38.6559C42.7185 36.3381 45.9892 39.6091 45.9892 43.6722V86.6657C45.9892 90.7288 41.8935 93.9998 37.8309 93.9998H13.3333C9.27067 93.9998 6 90.7288 6 86.6657V43.6722C6 39.6091 9.27067 36.3381 13.3333 36.3381Z",
    fill: "#FFC107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3353 68.321H86.6647C90.7285 68.321 94 71.633 94 75.7469V86.8951C94 91.0091 89.9032 94.321 85.8395 94.321H61.3353C57.2715 94.321 54 91.0091 54 86.8951V75.7469C54 71.633 57.2715 68.321 61.3353 68.321Z",
    fill: "#C0E0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3353 36H86.6647C90.7285 36 94 39.3119 94 43.4259V54.5741C94 58.6881 89.9032 62 85.8395 62H61.3353C57.2715 62 54 58.6881 54 54.5741V43.4259C54 39.3119 57.2715 36 61.3353 36Z",
    fill: "#C0E0FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosstable);
export default __webpack_public_path__ + "static/media/crosstable.54a073453c7b40c6ad7f35c9380258c4.svg";
export { ForwardRef as ReactComponent };